import { Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import product from "../assets/sedape.webp";

const MotionFlex = motion(Flex);
const MotionImage = motion(Image);
const MotionButton = motion(Button);
const MotionText = motion(Text);
const MotionHeading = motion(Heading);
const mercadoLivreLink = "https://www.mercadolivre.com.br/pagina/sedapecosmetico";

export default function Hero() {
  return (
    <MotionFlex
      direction={{ base: "column", md: "column", lg: "row" }}
      align="center"
      justify="space-between"
      gap={{ base: 10, md: 20 }}
      px={{ base: 6, md: 20 }}
      py={{ base: 16, md: 24 }}
      bg="#fff"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, type: "spring", stiffness: 10 }}
      letterSpacing="wide"
    >
      <Flex direction="column" maxW="lg" gap={6}>
        <MotionHeading
          fontFamily="heading"
          fontSize={{ base: "3xl", md: "4xl" }}
          color="sedapePinkDark"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8, type: "spring", stiffness: 60 }}
        >
          Sedapé: a jornada dos seus pés para uma maciez incomparável
        </MotionHeading>
        <MotionText
          fontSize="lg"
          color="gray.700"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Descubra o segredo para pés luxuosamente hidratados, regenerados e suaves com o
          creme hidratante exclusivo da Sedapé. Sinta o cuidado, o conforto e a beleza
          natural que seus pés merecem.
        </MotionText>
        <Button
          as="a"
          href={mercadoLivreLink}
          target="_blank"
          rel="noopener noreferrer"
          bg="sedapePink"
          color="white"
          size="lg"
          w="fit-content"
          _hover={{ bg: "sedapePinkDark" }}
        >
          Comprar agora
        </Button>
      </Flex>

      <MotionImage
        src={product}
        alt="Creme Sedapé"
        borderRadius="2xl"
        objectFit="cover"
        boxShadow="0 10px 20px rgba(0,0,0,0.2)"
        w="100vw"
        maxW={{ base: "100%", md: "70%", lg: "60%" }}
        initial={{ y: -20, opacity: 0, scale: 0.9 }}
        animate={{ y: [0, -10, 0], opacity: 1, scale: 1 }}
        transition={{ delay: 0.8, duration: 1.5, ease: "easeInOut" }}
      />
    </MotionFlex>
  );
}
